import React, { useEffect } from "react";

// Style
import "./Auth.scss";

// Lib
import { shallowEqual } from "react-redux";
import { useAppSelector } from "lib/hooks/useDispatch";

// Link
import { useNavigate } from "react-router-dom";

// components
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Tabs from "components/UiKit/Tabs";

export const Auth = () => {
  const navigate = useNavigate();

  const authorized = useAppSelector(
    (store) => store.settings.user.authorized,
    shallowEqual
  );

  const tabs = [
    { label: "Create your account", content: <SignUp />, url: "sign-up" },
    { label: "Already registered?", content: <SignIn />, url: "sign-in" }
  ];

  useEffect(() => {
    if (authorized) {
      navigate("/");
    }
  }, [authorized]);

  return (
    <div className="screen-auth">
      <div className="wrapper">
        <Tabs tabs={tabs} type="primary" defaultScreen="sign-up" className="screen-auth__tab" />
      </div>
    </div>
  );
};

export default Auth;
